import { api } from './index';
import { Methods } from './interfaces';

const getPublicProjects = (options: any) =>
  api<any, any>({
    method: Methods.GET,
    route: '/project/all',
    payload: options,
  });

const getProject = (id: string) =>
  api<any, any>({
    method: Methods.GET,
    route: `/project/all/${id}`,
  });

const updateProject = (id: string, options) =>
  api<any, any>({
    method: Methods.POST,
    route: `/project/all/${id}`,
    payload: options,
  });

const runProject = (code: string) =>
  api<any, any>({
    method: Methods.POST,
    route: `/project/run`,
    payload: { code },
  });

export const projectApi = {
  getPublicProjects,
  getProject,
  updateProject,
  runProject,
};
